import { ColDef } from 'ag-grid-community'
import { AlwaysEditableTextCellComponent } from '../cells/always-editable-text-cell.component'
import { TableHeaderComponent } from '../headers/table-header.component'
import { DateCellComponent } from '../cells/date-cell.component'
import { dateOnlyFormat, dateTimeFormat } from '../../../shared/utilities/date'
import { IntervalUsage } from 'src/app/shared/models/intervalUsage'
import { NumberCellComponent } from '../cells/number-cell.component'

const filterGroup = 'update_interval_usage'

export class UpdateIntervalUsageColumnDefinition {
  sharedDef: ColDef = {
    filter: false,
    sortable: false,
    editable: false,
    minWidth: 100,
    width: 150,
    flex: 1,
  }

  getColDefs = (): ColDef[] => [
    {
      ...this.sharedDef,
      headerName: 'Time',
      field: 'market_interval',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: `${dateOnlyFormat} HH:00`,
        date: (d: IntervalUsage) => d.market_interval,
      },
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
    {
      ...this.sharedDef,
      headerName: 'Last Value (kW\u00A0h)',
      field: 'measurement_value',
      cellRenderer: NumberCellComponent,
      cellRendererParams: {
        num: (d: IntervalUsage) => d.measurement_value,
        precision: 8,
      },
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
    {
      ...this.sharedDef,
      width: 175,
      field: 'override',
      headerName: 'Override (kW\u00A0h)',
      cellRenderer: AlwaysEditableTextCellComponent,
      cellRendererParams: {
        inputFilter: (value: string) => /^-?\d*[.,]?\d*$/.test(value),
      },
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
    {
      ...this.sharedDef,
      width: 175,
      headerName: 'Last Updated At',
      field: 'last_update_time',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: dateTimeFormat,
        date: (d: IntervalUsage) => d.last_update_time,
        viewAsTz: 'America/Chicago',
      },
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
    {
      ...this.sharedDef,
      width: 175,
      headerName: 'Last Updated By',
      field: 'last_updated_by',
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
  ]
}
